import { getCookie } from './Cookies';

function getTokens() {
  const wcToken = getCookie('WC_TOKEN');
  const userId = wcToken ? wcToken.split('%')[0] : '';
  const wcTrustedToken = getCookie(`WC_AUTHENTICATION_${userId}`);
  const ripleyToken = getCookie('RIPLEY_CUSTOMER_TOKEN');
  const ripleyRefreshToken = getCookie('RIPLEY_CUSTOMER_REFRESH_TOKEN');
  const wcUserActivity = getCookie(`WC_USERACTIVITY_${userId}`);
  const wcPersistent = getCookie('WC_PERSISTENT');
  const wcSessionCustomer = getCookie('WC_SESSION_CUSTOMER_ID');
  const wcActivePointer = getCookie('WC_ACTIVEPOINTER');
  const wcSessionEstablished = getCookie('WC_SESSION_ESTABLISHED');

  return {
    wcToken: () => decodeURIComponent(wcToken),
    wcTrustedToken: () => wcTrustedToken,
    ripleyToken: () => ripleyToken,
    ripleyRefreshToken: () => ripleyRefreshToken,
    wcUserActivity: () => wcUserActivity,
    wcPersistent: () => wcPersistent,
    wcSessionCustomer: () => wcSessionCustomer,
    wcActivePointer: () => wcActivePointer,
    wcSessionEstablished: () => wcSessionEstablished,
  };
}

export default getTokens;
